import React, { Component } from 'react';
import {Card, Table, Modal, Button, Input, Form, Upload, Icon, InputNumber, Pagination, message} from 'antd';
import {
    imageSourceAdd,
    imageSourceDelete,
    imageSourceGetById,
    imageSourceListInitDataSource,
    imageSourceUpdate
} from "../../../actions/imageSourceList";
import {HEADER_HEIGHT, PIC_TYPE} from "../../../constants";
import BaseTable from "../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import UploadWall from "../../../components/upload/UploadWall";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import $Jq from "jquery";
const start = 1;//从1第一页开始
const size = 10;//每页10条

/** 列表 */
class ImageSourceList extends BaseComponent {
    columns = [
        {
            title: '图片地址',
            dataIndex: 'imageUrl',
            key: 'imageUrl',
            width:139,
            render: (text, record) => (
                <Titlepicfile src={text} style={{width:24, height:24}}/>
            ),
        },
        {
            title: '链接地址（留空默认链接原图片）',
            dataIndex: 'linkAddress',
            key: 'linkAddress',
            width: 405,
            ellipsis: true,
            render: (text, record) => (
                <div  title={text}
                      style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                      }}>{text}</div>
            ),
        },
        {
            title: '尺寸',
            dataIndex: 'imageWidth',
            key: 'imageWidth',
            render: (text, record) => (
                    `${record.imageWidth}*${record.imageHeight}`
            ),
            width: 156
        },
        {
            title: '显示次序',
            dataIndex: 'showOrder',
            key: 'showOrder',
            width: 152
        },
        {
            title: '说明',
            dataIndex: 'instructions',
            key: 'instructions',
            ellipsis: true,
            render: (text, record) => (
                <div  title={text}
                      style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                      }}>{text}</div>
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
               <div style={{marginLeft:'-17px',display:this.state.disable == 1 ? "none" : ""}}>
                   <Button  type="link" onClick={()=>this.updateImageSource(record)}>修改</Button>
                   <Button  type="link" onClick={()=>this.deleteImageSource([record])}>删除</Button>
               </div>

            ),
            width: 169
        }
    ];
    constructor(props) {
        super(props);
        this.state = {
            start : start,
            size : size,
            total: 0,
            selectedRows:[],
            data:[],
            params:this.props.match.params,
            mediaId:'',
            contentId:'',
            disable:1
        }
    }

    componentDidMount() {
        let mediaId =this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        this.state.mediaId = mediaId;
        let contentId = this.props.match.params.contentId ? this.props.match.params.contentId : '';
        this.state.contentId = contentId;
        this.initDataSource(this.state.start, this.state.size);
        this.getMediaById()

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.params=nextProps.match.params
        this.initDataSource(this.state.start, this.state.size);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    render() {
        const type = "checkbox";//也可以是radio
        let selectedRowKeys = this.getSelectedRowKeys();
        let height = window.innerHeight - HEADER_HEIGHT - 15 - 15;
        return (
            <div style={{
                backgroundColor: 'white',
                height: height,
                margin: 'auto',
                marginTop: 15,
                marginLeft:15,
                borderRadius: '5px',
                overflow: 'hidden',
            }}>
                {/*新增按钮*/}
                {this.renderAddBtn()}
                {/*<Button type="danger" style={{marginLeft:"10px",marginBottom:"20px"}} onClick={()=>this.deleteImageSource(this.state.selectedRows)}>批量删除</Button>*/}
                {/*表格*/}
                {this.renderTable()}
                {/*分页栏*/}
                {this.renderPage()}
                <ImageSourceModal {...this.props.match.params} ref={"imageSourceModal"}/>
            </div>

        );
    }

    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    paginationOnChange(page, pageSize){
        console.log(this.state.params);
        let body={
            page,
            size: pageSize,
            mediaId: this.state.params.mediaId,
            contentId: this.state.params.contentId
        };
        imageSourceListInitDataSource(body,(res)=>{
            this.setState(prevState => {
                return {
                    ...prevState,
                    start : page,
                    size : pageSize,
                    total: res.count,
                    data: (()=>{
                        for(let i = 0; res.data && i < res.data.length; i++){
                            //这个key是react的item必须的，如果没有这会按照索引来。但是复选框就会出问题了。
                            //当选择了某个选项，再翻页后，会将新页码中的数据也选中
                            if(!res.data[i].key){
                                res.data[i].key = res.data[i].id;
                            }
                        }
                        return res.data;
                    })(),
                    selectedRows:[]
                }
            })
        });
    }

    onSelect = (record, selected, selectedRows, nativeEvent)=>{
        this.setState({
            selectedRows: selectedRows
        })
    };

    onSelectAll = (selected, selectedRows, changeRows) => {
        this.setState({
            selectedRows: selectedRows
        })
    };

    //修改按钮接口
    updateImageSource = (imageSource) => {
        let fieldData = {
            ...imageSource,
            ...this.state.params
        };
        this.refs.imageSourceModal.showModal("修改", fieldData, imageSourceGetById, imageSourceUpdate, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });

    };
    //获取当前用户下是被禁用
    getMediaById = () => {
        this.request({
            url: "/cm-sites-pms/media/getById",
            body: {
                mediaId:this.state.mediaId
            },
            callBack: (res) => {
                let disable = 0;
                if(res) {
                    disable = res.disable
                }
                this.setState({disable});
            }
        })
    };
    //新增按钮功能
    addImageSource = () => {
        this.refs.imageSourceModal.showModal("新增", this.state.params, null, imageSourceAdd, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    deleteImageSource = (selectedRows) => {
        let that = this;
        if(!selectedRows || selectedRows.length === 0){
            Modal.error({
                title: '请选择要删除的项',
                okText:"确定"
            });
            return;
        }
        Modal.confirm({
            title: '删除图片源',
            content: '删除后无法恢复，确定删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: ()=>{
                let ids = [];
                for(let i = 0; selectedRows && i < selectedRows.length; i ++){
                    let id = selectedRows[i].id;
                    ids.push(id);
                }
                if(ids && ids.length === 1){
                    imageSourceDelete({id:ids[0]},()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState(prevState =>{
                        let tempSelectedRows = [];
                        for(let j = 0; prevState.selectedRows && j < prevState.selectedRows.length; j ++){
                            let row = prevState.selectedRows[j];
                            if(row.id !== ids[0]){
                                tempSelectedRows.push(row);
                            }
                        }
                        return {
                            ...prevState,
                            selectedRows:tempSelectedRows
                        };
                    })
                }else if(ids && ids.length > 1){
                    // imageSourceDeletes(ids,()=>{
                    //     //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                    //     //那么页码就得往前翻一页
                    //     if(ids.length === that.state.data.length
                    //         && Math.ceil(that.state.total / that.state.size) === this.state.start
                    //         && this.state.start != 1){
                    //         this.paginationOnChange(that.state.start - 1, that.state.size);
                    //     }else{
                    //         this.paginationOnChange(that.state.start, that.state.size);
                    //     }
                    // });
                    that.setState({
                        selectedRows:[]
                    });
                }
            }
        });
    };

    //获取选中的项，用于回显
    getSelectedRowKeys = ()=>{
        let selectedRowKeys = [];
        for(let j = 0; this.state.selectedRows && j < this.state.selectedRows.length; j ++){
            let row = this.state.selectedRows[j];
            selectedRowKeys.push(row.key);
        }
        return selectedRowKeys;
    };

    //分页器搜索功能
    onChange = (type, e) => {
        switch (type) {
            case 'page':
                this.state.start = e;
                break;
            case 'size':
                this.state.size = e;
                this.state.start = 1;
                break;
        }
        this.getImageData()
    };

    //分页栏
    renderPage = () => {
        let {total, start, size, data} = this.state;
        if(!total) return <div style={{height:81}}></div>;
        if(!(data&&data.length>0) && start>1) {
            this.onChange('page', --start, size)
        }
        return (
            <div style={{
                display: "flex",
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #f6f8fd',
                padding: '24px 32px',
            }}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={start}
                    pageSize={size}
                    onChange={(page, pageSize) => {
                        this.onChange('page', page, pageSize)
                    }} //页码改变时回调
                    onShowSizeChange={(page, pageSize) => {
                        this.onChange('size', page, pageSize)
                    }} //每页条数改变回调
                />
            </div>
        )
    };
    //新增按钮
    renderAddBtn=()=>{
        return(
           this.state.disable == 1 ? "" : <div style={{paddingLeft: "32px", paddingTop:"24px"}}>
               <Button type="primary" onClick={() => this.addImageSource()}>新增</Button>
           </div>
        )
    };
    //表格
    renderTable=()=>{
        let tableHeight = window.innerHeight - HEADER_HEIGHT - 96 - 80 - 15 - 15 - 15;
        return(
            <div className="cm-table-body" style={{paddingLeft: 32, paddingTop:24,paddingRight:32}}>
                <Scrollbars autoHeight autoHeightMax={tableHeight} autoHide>
                    <BaseTable columns={this.columns} dataSource={this.state.data}/>
                </Scrollbars>
            </div>
        )
    }
}

/** 弹窗 */
class ImageSourceModal extends BaseComponent{
    constructor(props) {
        super(props);
        this.state = {
            title: "信息",
            visible: false,
            fieldData: {},
            confirmLoading: false,
            params:{
                "contentId": 0,
                "createTime": 0,
                "id": "",
                "imageHeight": 0,
                "imageUrl": "",
                "imageWidth": 0,
                "instructions": "",
                "linkAddress": "",
                "mediaId": "",
                "showOrder": 0,
                "treeId": 0,
                "updateTime": 0,
                "wbImageId": 0
            }
        };
    }

    componentDidMount() {
        console.log(this.props)
        this.state.params.contentId=this.props.contentId;
        console.log(this.state.params.contentId)
        this.state.params.mediaId=this.props.mediaId;
    }

    closeBallBack(){

    };
    okCallBack(){

    };

    showModal = (title, fieldData, showCallBack, okCallBack, closeCallBack) => {
        console.log(fieldData);
        if (showCallBack) {
            showCallBack({id: fieldData.id}, (res) => {
                this.setState({
                    title: title,
                    visible: true,
                    fieldData: (()=>{
                        if(!res){
                            return null;
                        }
                        let value = {};
                        for(let attr in res){
                            value[attr] = {
                                value: res[attr]
                            }
                        }
                        return value;
                    })()
                });
            });
        }else {
            this.setState({
                title: title,
                visible: true,
            })
        }
        this.okCallBack = okCallBack;
        this.closeBallBack = closeCallBack;
    };
    //新增弹窗确认按钮函数
    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });
        let that = this;

        let wrappedImageSourceModalForm = this.refs.wrappedImageSourceModalForm;//通过refs属性可以获得对话框内form对象
        wrappedImageSourceModalForm.validateFields((err, values) => {
            console.log(values)
            console.log(this.props)
            let body={...values,...this.props}
            if(!err){
                if(!values.showOrder){
                    values.showOrder = 1;
                }
                if(!values.instructions)
                {
                    values.instructions = "";
                }
                that.okCallBack(body, function(){
                    that.setState({
                        visible: false,
                        confirmLoading: false,
                    });
                    wrappedImageSourceModalForm.resetFields();
                    if(that.closeBallBack){
                        that.closeBallBack();
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = () => {
        let wrappedImageSourceModalForm = this.refs.wrappedImageSourceModalForm;
        wrappedImageSourceModalForm.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title={this.state.title}
                visible={visible}
                onOk={this.handleOk}
                okText={"确定"}
                maskClosable={true}
                cancelText={"取消"}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
                width={650}
            >
                <WrappedImageSourceModalForm fieldData={this.state.fieldData} ref={"wrappedImageSourceModalForm"} />
            </Modal>
        );
    }
}

/** 表单 */
class ImageSourceModalForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    changeImageUrl = (file) => {
        if(file.status === 'uploading'){
            window.loading.show()
        }else {
            window.loading.hide()
        }
        const { setFieldsValue } = this.props.form;
        setFieldsValue({"imageUrl":file.url,"imageWidth":file.width,"imageHeight":file.height});
    };
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return (
            <Form {...formItemLayout}>
                {getFieldDecorator('id',{
                    // initialValue:""
                })(
                    <Input type={"hidden"}/>
                )}
                {getFieldDecorator('mediaCode')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('treeId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('treeContentId')(
                    <Input type={"hidden"} />
                )}
                {getFieldDecorator('wbImageId',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
                <Form.Item label="图片地址">
                    {getFieldDecorator('imageUrl', {
                        rules: [{ required: true, message: '请上传图片!' }],
                    })(
                        <Input />
                    )}
                    <ImageUpload onChange={(file) => this.changeImageUrl(file)} />
                </Form.Item>
                <Form.Item label="说明">
                    {getFieldDecorator('instructions',{
                        rules: [{type:'string',max:120,message: '说明文字不能超过120字!'}]
                    })(
                        <Input placeholder="请输入说明" />
                    )}
                </Form.Item>
                <Form.Item label="链接地址">
                    {getFieldDecorator('linkAddress',{
                        rules: [{message: '请输入正确的链接地址!', pattern: new RegExp(/http[s]{0,1}:\/\/([\w.]+\/?)\S*/)}],
                    })(
                        <Input placeholder="请输入链接地址" />
                    )}
                </Form.Item>
                <Form.Item label="图片宽度">
                    {getFieldDecorator('imageWidth',{
                        rules: [{ required: true, message: '请输入图片宽度!' }],
                    })(
                        <InputNumber min={1}/>
                    )}
                    <span style={{marginLeft:"5px"}}>本图片的显示宽度</span>
                </Form.Item>
                <Form.Item label="图片高度">
                    {getFieldDecorator('imageHeight',{
                        rules: [{ required: true, message: '请输入图片高度!' }],
                    })(
                        <InputNumber min={1}/>
                    )}
                    <span style={{marginLeft:"5px"}}>本图片的显示高度</span>
                </Form.Item>
                <Form.Item label="显示次序">
                    {getFieldDecorator('showOrder',{initialValue:1})(
                        <InputNumber min={1} />
                    )}
                    <span style={{marginLeft:"5px"}}>本图片在页面组件中显示的次序</span>
                </Form.Item>
            </Form>
        );
    }
}

const WrappedImageSourceModalForm = Form.create()(ImageSourceModalForm);

class ImageUpload extends Component{

    constructor(props){
        super(props);
    }

    state = {
        fileUrl : "",
        fileList:[],
        picType:['jpg','jpeg', 'gif', 'png', 'bmp'],
    };

    render() {
        let {fileList} = this.state;
        return (
                <UploadWall
                    accept={"."+this.state.picType.join(",.")}
                    multiple={true}
                    action="/storage/uploadFile"
                    listType={'list'}
                    fileList={fileList} // 上传文件的列表
                    style={{padding:'unset'}}
                    customRequest={new ChunkUpload({
                        checkFileURL:"/storage/checkFile",
                        checkChunkURL:"/storage/checkChunk",
                        uploadChunkURL:"/storage/uploadChunk",
                        chunkUploadOverURL:"/storage/chunkIsUploadOver",
                        mergeChunksURL:"/storage/mergeChunk"
                    }).start}
                    uploadBtnName={"点击上传"}
                    beforeUpload={this.beforeUpload}
                    onChange={this.onChange}
                    showPercent={false}
                />
        );
    }

    // beforeUpload =  file => {
        // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        // if (!isJpgOrPng) {
        //     message.error("You can only upload JPG/PNG file!");
        // }
        // const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isLt2M) {
        //     message.error("Image must smaller than 2MB!");
        // }
        // if(file.name){
        //     var fileCheckRegex=/[0-9]{8}-.*?-.*?-.*/;
        //     if(!fileCheckRegex.test(file.name)){
        //         message.error( "文件名称必须符合《yyyymmdd-活动名称-拍摄者-资源说明》格式",
        //             window.top.sysConfig.getValueByKey("showtime",3),
        //         );
        //         return  false;
        //     }
        // }
        // return isJpgOrPng;
    //     return true
    // };
    beforeUpload = async file => {
        let newPicTypeList = [...this.state.picType, ...this.state.picType.toUpperCase()]
        return new Promise((resolve, reject) => {
            let status = newPicTypeList.some(item => item === file.name.split('.')[file.name.split('.').length - 1]);
            if (!status) {
                console.log('status',status)
                message.destroy();
                message.error(`不支持此格式！`);
                reject();
            }else{
                resolve();
            }
        });
    };

    onChange = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.height = info.file.response && info.file.response.height;
                item.width = info.file.response && info.file.response.width;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.props.onChange(JSON.parse(JSON.stringify(info.fileList.at(-1))));
        this.setState({
            fileList: [info.fileList.at(-1)]
        })
    };
}

export default ImageSourceList;